import PropertyStateEnum from '~Api/Deal/PropertyStateEnum';
import ValuerTypeEnum from '~Api/Application/ValuerTypeEnum';
import IValuer from './IValuer';

export function parseValuer(raw: any): IValuer {
    return {
        email: raw.email,
        name: raw.name,
        phone: raw.phone,
        state: raw.state as PropertyStateEnum,
        type: raw.type as ValuerTypeEnum,
        uuid: raw.uuid,
    };
}
